const Unauthorized = () => {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>403</h1>
      <p>You are not authorized to access this page.</p>
    </div>
  );
};

export default Unauthorized;
